import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ModuleAssignment, IAssignment } from '../../module/models';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssignmentStatus } from '../utilities/enums';

@Injectable()
export class MasterService {
  noMoreAssignments$: BehaviorSubject<boolean>;
  redoRequested$: Subject<number>;

  private _index: number;
  private _currentModuleAssignment: ModuleAssignment;

  constructor(private _router: Router
    , private _http: HttpClient) {

    this.noMoreAssignments$ = new BehaviorSubject<boolean>(false);
    this.redoRequested$ = new Subject<number>();

    _router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url.indexOf("viewer") != -1) {
        let url = event.url;
        let lessonAssignmentId = +url.substring(url.lastIndexOf('/') + 1);
        this._index = this.CurrentModuleAssignment.Assignments.findIndex(x => x.Id == lessonAssignmentId && x.IsTest == false);
        this._isLastSequentialAssignment();
      }
      else if (event instanceof NavigationEnd && event.url.indexOf("test") != -1 && event.url.indexOf("videotest") == -1) {
        let url = event.url;
        let testAssignmentId = +url.substring(url.lastIndexOf('/') + 1);
        this._index = this.CurrentModuleAssignment.Assignments.findIndex(x => x.Id == testAssignmentId && x.IsTest == true);
        this._isLastSequentialAssignment();
      }
    });
  }

  get CurrentModuleAssignment(): ModuleAssignment {
    return this._currentModuleAssignment;
  }
  set CurrentModuleAssignment(value: ModuleAssignment) {
    this._currentModuleAssignment = value;
  }

  private _isLastSequentialAssignment() {
    if (this._index + 1 < this.CurrentModuleAssignment.Assignments.length) {
      this.noMoreAssignments$.next(false);
    }
    else {

      this._http.get('api/module/is-last-sequential-module-assignment/' + this.CurrentModuleAssignment.Id).pipe(
        map(response => <boolean>response))
        .subscribe(isLast => {
          this.noMoreAssignments$.next(isLast);
        });
    }
  }

  private goToLesson(lessonAssignmentId: number) {

    this._router.navigate(['/viewer', lessonAssignmentId]);

    let previousUrl = this._router.url;
    if (previousUrl == "/viewer/" + lessonAssignmentId) {
      this.redoRequested$.next(lessonAssignmentId);
    }
  }

  private goToTest(testAssignmentId: number) {

    this._router.navigate(['/test', testAssignmentId]);

    let previousUrl = this._router.url;
    if (previousUrl == "/test/" + testAssignmentId) {
      this.redoRequested$.next(testAssignmentId);
    }
  }

  public goToInProgressAssignment(lessonAssignmentId?: number) {

    let assignments = this.CurrentModuleAssignment.Assignments;
    let tempAssignments: IAssignment[] = [];

    //Find the first IAssignment with AssignmentStatusId that is in progress
    let assignment: IAssignment = null;
    for (let ct = 0; ct < assignments.length; ct++) {
      if (lessonAssignmentId) {
        if (assignments[ct].LessonAssignmentId == lessonAssignmentId &&
          assignments[ct].AssignmentStatusId == AssignmentStatus.InProgress) {
          assignment = assignments[ct];
          break;
        }
        else if (assignments[ct].LessonAssignmentId == lessonAssignmentId) {
          tempAssignments.push(assignments[ct]);
        }
      }
      else {
        if (assignments[ct].AssignmentStatusId == AssignmentStatus.InProgress) {
          assignment = assignments[ct];
          break;
        }
        else {
          tempAssignments.push(assignments[ct]);
        }
      }
    }

    //If no in-progress assignments were found, get the first IAssignment
    if (assignment == null && tempAssignments.length > 0) {
      assignment = tempAssignments.shift();
    }

    if (assignment != null && assignment.IsTest == true) {
      this.goToTest(assignment.Id);
    }
    else if (assignment != null && assignment.IsTest == false) {
      this.goToLesson(assignment.Id);
    }
  }

  public goToNext() {
    //check if all module assignments are complete
    if (this.CurrentModuleAssignment.Assignments.filter(x => x.AssignmentStatusId == AssignmentStatus.Complete).length == this.CurrentModuleAssignment.Assignments.length) {
      this.goToModuleComplete();
    }//next module assignment
    else if (this._index + 1 < this.CurrentModuleAssignment.Assignments.length) {
      let nextAssignment = this.CurrentModuleAssignment.Assignments[this._index + 1];
      if (nextAssignment.IsTest == true) {
        this.goToTest(nextAssignment.Id);
      }
      else {
        this.goToLesson(nextAssignment.Id);
      }
    }//next sequential assignment
    else {
      this._http.get('api/module/next-sequential-module-assignment/' + this.CurrentModuleAssignment.Id).pipe(
        map(response => new ModuleAssignment(response))
      ).subscribe(data => {
        if (!data || !data.Assignments) {
          this._router.navigate(['/summary', this.CurrentModuleAssignment.CourseId]);
        }
        else {
          this._currentModuleAssignment = data;
          this.goToInProgressAssignment();
        }
      });
    }
  }

  public goToModuleComplete() {
    this._router.navigate(['/module-complete', this.CurrentModuleAssignment.ModuleId]);
  }

  public goToNextModule(moduleAssignment: ModuleAssignment) {
    if (!moduleAssignment || !moduleAssignment.Assignments) {
      this._router.navigate(['/summary', this.CurrentModuleAssignment.CourseId]);
    }
    else {
      this._currentModuleAssignment = moduleAssignment;
      this.goToInProgressAssignment();
    }
  }

  public goToReview() {
    let previousLesson = null;
    var ct = this._index;
    while (ct >= 0) {
      previousLesson = this.CurrentModuleAssignment.Assignments[ct];
      if (previousLesson.IsTest == false) {
        break;
      }
      ct--;
    }
    this.goToLesson(previousLesson.Id);
  }

  public redo() {
    let currentAssignment = this.CurrentModuleAssignment.Assignments[this._index];
    if (currentAssignment.IsTest == true) {
      this.goToTest(currentAssignment.Id);
    }
    else {
      this.goToLesson(currentAssignment.Id);
    }
  }
}
